function SectionTitle({ title }) {
  return (
    <div className="section-heading">
      <h1 className="page-title">{title}</h1>
    </div>
  );
}

export default SectionTitle;
